import { render, staticRenderFns } from "./viewCredentials.vue?vue&type=template&id=36d2b674&scoped=true&"
import script from "./viewCredentials.vue?vue&type=script&lang=js&"
export * from "./viewCredentials.vue?vue&type=script&lang=js&"
import style0 from "./viewCredentials.vue?vue&type=style&index=0&id=36d2b674&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36d2b674",
  null
  
)

export default component.exports